//export const API_URL = 'http://192.168.2.39:8080/v1'

export const API_URL = process.env.REACT_APP_URL

// export const API_URL ='http://192.168.2.32:4581/v1'
